/**
 * @file コンポーネント：執刀医リスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Surgeon } from "~/src/components/projects/Surgeon";

// スタイル読み込み
import { StyledSurgeonlist, StyledSurgeonlistItem } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledSurgeonlist>
            {/* 執刀医の数だけループ */}
            {props.surgeonlist.map((surgeon, index) => (
                <StyledSurgeonlistItem key={"surgeon-" + index}>
                    <Surgeon
                        fnSetModalEdit={props.fnSetModalEdit}
                        id={surgeon.id}
                        isEditPage={props.isEditPage}
                        name={surgeon.name}
                        nolink={props.nolink}
                        onColor={props.onColor}
                    />
                </StyledSurgeonlistItem>
            ))}
        </StyledSurgeonlist>
    );
};
